import styled from 'styled-components';

export const NodeStyled = styled.div`
  position: relative;
  margin-bottom: 30px;
  background-color: ${({ theme }) => theme.colors.neutral0};
  display: flex;
  justify-content: center;

  transition: all 300ms ease;

  > div:first-child {
    background: ${({ theme }) => theme.colors.primary900};

    border: ${({ theme }) => `1px solid ${theme.colors.primary900}`};
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 300ms ease;
    padding: 10px;
    text-align: center;
  }

  > div > div:nth-child(2) {
    /* width: 100%; */
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
`;

export const NodeImage = styled.div<{ image: any; condensed: boolean }>`
  width: 200px;
  height: auto;
  display: flex;
  flex-grow: 1;
  border-radius: 30px;
  flex: none;
  aspect-ratio: 1/1;
  background: url(${({ image }) => image});
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
`;
